import styled, { keyframes } from 'styled-components';
const bounce = keyframes `
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
`;
export const LoadingContainer = styled.div `
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs}px;
  width: fit-content;
`;
export const Dot = styled.div `
  width: ${({ theme }) => theme.spacing.xs}px;
  border-radius: ${({ theme }) => theme.border_radius.xs};
  aspect-ratio: 1;
  background: ${({ theme }) => theme.colors.grey_2};
  flex-shrink: 0;
  animation: ${bounce} 1.4s ease-in-out infinite both;

  &:nth-child(1) {
    animation-delay: -0.32s;
  }

  &:nth-child(2) {
    animation-delay: -0.16s;
  }

  &:nth-child(3) {
    animation-delay: 0s;
  }
`;
